export function normalizeLinkUrl(raw = '') {
    const value = String(raw).trim();
    if (!value) return '';
    if (/^https?:\/\//i.test(value)) return value;
    if (value.startsWith('www.')) return `https://${value}`;
    if (/^[a-z0-9.-]+\.[a-z]{2,}([/?#].*)?$/i.test(value)) {
        return `https://${value}`;
    }
    return value;
}

export function buildLinkCommandPayload(rawUrl = '', openInNewTab = false) {
    const url = normalizeLinkUrl(rawUrl);
    if (!url) return null;

    return {
        url,
        target: openInNewTab ? '_blank' : null,
        rel: openInNewTab ? 'noopener noreferrer' : null,
        title: openInNewTab ? 'newtab' : null,
    };
}
